import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import HomeHotFormulasContent from './components/HomeHotFormulasContent';

export default function HomeHotFormulasPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '熱銷配方｜12 大保健食品市場熱門配方方向｜康永生技',
    description: '12 大保健食品市場熱門配方方向：美肌、女性私密、男性魅力、順暢輕盈、水潤晶亮等，康永提供完整配方設計與劑型選擇。',
    keywords: '熱銷配方,保健食品配方,配方設計,ODM配方,保健食品市場趨勢',
    lang: 'zh-TW',
    canonicalPath: '/home/hot-formulas',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="熱銷配方｜12 大保健食品市場熱門配方方向｜康永生技" pageDescription="12 大保健食品市場熱門配方方向：美肌、女性私密、男性魅力、順暢輕盈、水潤晶亮等，康永提供完整配方設計與劑型選擇。" pageUrl={`${siteUrl}/home/hot-formulas`} />
      <HomeHotFormulasContent />
    </Layout>
  );
}